import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksInternalFieldOptionConstructor,
  QuickBooksInternalFieldOption,
} from './QuickBooksInternalFieldOption'

export const QuickBooksInternalFieldOptionConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksInternalFieldOptionConstructor>({
    key: Factory.each(() => faker.lorem.slug()),
  })

export const QuickBooksInternalFieldOptionFactory = EntityFactory(
  QuickBooksInternalFieldOption,
  QuickBooksInternalFieldOptionConstructorFactory
)
